module.exports = __webpack_public_path__ + "static/media/freeSampleForms.dec5531c.pdf";